import Joi from 'joi';
import { actionCreator, objectSchemaOf } from '../helpers';
import type { RequestedBy } from './showKeyboardAction';
import { requestedBySchema } from './showKeyboardAction';

export const SHOW_OPTIONS = 'USER_INPUT/SHOW_OPTIONS';

export interface IOption {
  text: string;
  intent: string;
}

export const optionSchema = objectSchemaOf<IOption>({
  text: Joi.string().required(),
  intent: Joi.string().required(),
});

export interface IShowOptionsPayload {
  conversationId: string;
  message: string;
  requestedBy?: RequestedBy;
  options: IOption[];
}

export const showOptionsPayloadSchema = objectSchemaOf<IShowOptionsPayload>({
  conversationId: Joi.string().required(),
  message: Joi.string().required(),
  requestedBy: requestedBySchema.optional(),
  options: Joi.array().items(optionSchema).required().min(1),
});

export interface IShowOptionsAction {
  type: typeof SHOW_OPTIONS;
  payload: IShowOptionsPayload;
}

export const showOptionsActionSchema = objectSchemaOf<IShowOptionsAction>({
  type: Joi.string().required().valid(SHOW_OPTIONS),
  payload: showOptionsPayloadSchema.required(),
});

export const showOptionsParamsSchema = showOptionsPayloadSchema.required();

export const showOptions = actionCreator({
  type: SHOW_OPTIONS,
  schema: showOptionsActionSchema,
});
